import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";
import { applyBranding } from "../lib/branding";

const SettingsCtx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (err) {
      if (err?.response?.status && err.response.status !== 401) {
        console.error("SettingsContext refresh failed:", err);
      }
      setSettings(null);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => { applyBranding(settings || {}); }, [settings]);

  const value = useMemo(
    () => ({ settings, refresh, setSettings }),
    [settings, refresh]
  );

  return <SettingsCtx.Provider value={value}>{children}</SettingsCtx.Provider>;
}

export const useSettings = () => useContext(SettingsCtx);
